<template>
    <BaseMultiselect
        :value="props.value"
        :options="documentTypeOptions"
        value-key="type"
        label-key="label"
        :label="props.label"
        :name="props.name"
        :rules="props.rules"
        :placeholder="props.placeholder"
        :disabled="props.disabled"
        :api-validation-error="props.apiValidationError"
        :multiple="false"
        @input="val => emit('input', val)"
    />
</template>

<script setup>
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';

    /**
     * DocumentTypePicker — Selector de tipo de documento para admin.
     *
     * Wrapper sobre BaseMultiselect con opciones hardcodeadas
     * (DNI / NIE / NIF / PASAPORTE / OTROS).
     *
     * @prop {String}  value               — Valor seleccionado (v-model via @input).
     * @prop {String}  [label]             — Label flotante.
     * @prop {String}  [name]              — Nombre del campo para VeeValidate.
     * @prop {String|Object} [rules]       — Reglas de validación VeeValidate.
     * @prop {String}  [placeholder]       — Placeholder.
     * @prop {Boolean} [disabled]          — Deshabilitar.
     * @prop {String|Array} [apiValidationError] — Error del servidor.
     *
     * @emits input — Nuevo valor (string con el type: 'DNI' | 'NIE' | etc.).
     */
    const props = defineProps({
        value: String,
        label: { type: String, default: 'Tipo de identificación' },
        name: String,
        rules: [String, Object],
        placeholder: String,
        disabled: Boolean,
        apiValidationError: [String, Array],
    });

    const emit = defineEmits(['input']);

    const documentTypeOptions = [
        { type: 'DNI', label: 'DNI' },
        { type: 'NIE', label: 'NIE' },
        { type: 'NIF', label: 'NIF' },
        { type: 'PASAPORTE', label: 'PASAPORTE' },
        { type: 'OTROS', label: 'OTROS' },
    ];
</script>

<script>
    export default {
        inheritAttrs: false,
    };
</script>
